export default "__VITE_ASSET__B8Ss2Wlx__"